import { useState } from 'react';
import styled, { css } from 'styled-components';
import {
  flexBoxCenter,
  flexDirectionColumn,
  justifyContentFlexStart,
  justifyContentSpaceBetween,
  layerA,
  layerA180Deg,
  layerADark,
  layerB,
} from '../styles/commonStyles';
import SelectMachineOptions from './controls/mainSelection/SelectMachineOptions';
import { useDispatch, useSelector } from 'react-redux';
import {
  handleIsReadyToSelectProgram,
  handleOpenSelectLocation,
  handleUnselectProgram,
  selectMobileMC,
} from '../store/slices/mobileMasterControlSlice';
import { selectEssSwitch } from '../store/slices/essSwitchSlice';
import { selectTgsSwitch } from '../store/slices/tgsSwitchSlice';
import { selectTesSwitch } from '../store/slices/tesSwitchSlice';

import {
  selectMasterControls,
  handleLocationSelect,
  handleMachineSelect,
  handleResetAllSelect,
  handleSelectAll,
} from '../store/slices/masterControlSelectSlice';

import { useEffect } from 'react';

const MobileSelectLocation = ({ setIsApply }) => {
  const MCStatus = useSelector(selectMobileMC);
  const { selectedSwt, isOpenSelectLocation } = MCStatus;

  const { essSwitch: essSwt } = useSelector(selectEssSwitch);
  const { tgsSwitch: tgsSwt } = useSelector(selectTgsSwitch);
  const { tesSwitch: tesSwt } = useSelector(selectTesSwitch);

  const selectLocationStatus = useSelector(selectMasterControls);
  const { ess, tgs, tes } = selectLocationStatus;

  const { selectedOne } =
    selectedSwt === 'ess' ? ess : selectedSwt === 'tgs' ? tgs : tes;

  useEffect(() => {
    if (selectedOne) {
      dispatch(handleIsReadyToSelectProgram(true));
    } else {
      dispatch(handleIsReadyToSelectProgram(false));
    }
  }, [selectedOne]);

  useEffect(() => {
    return () => {
      dispatch(handleResetAllSelect());
    };
  }, []);

  useEffect(() => {
    if (!selectedSwt) {
      dispatch(handleOpenSelectLocation(false));
    }
  }, [selectedSwt]);

  const arrowSrc = isOpenSelectLocation
    ? '/images/masterCtr-select-btn.svg'
    : '/images/masterCtr-select-btn.svg';

  const dispatch = useDispatch();

  const handleOpenSelect = () => {
    dispatch(handleOpenSelectLocation());
    setIsApply(false);
  };

  return (
    <Wrapper isExpanded={isOpenSelectLocation}>
      <InnerWrapper isExpanded={isOpenSelectLocation}>
        <SelectedOneAndArrowButton>
          <SelectedOneWrapper>
            <SelectedOne>
              {selectedOne ? selectedOne : 'select switch location'}
            </SelectedOne>
          </SelectedOneWrapper>
          <ExpandButton onClick={() => selectedSwt && handleOpenSelect()}>
            <Icon src={arrowSrc} />
          </ExpandButton>
        </SelectedOneAndArrowButton>
        {isOpenSelectLocation && (
          <SelectMachineOptions
            isMasterControl={true}
            handleClose={handleOpenSelect}
            data={
              selectedSwt === 'ess'
                ? essSwt
                : selectedSwt === 'tes'
                ? tesSwt
                : tgsSwt
            }
            swt={selectedSwt}
          />
        )}
      </InnerWrapper>
    </Wrapper>
  );
};

export default MobileSelectLocation;

const Wrapper = styled.div`
  width: 248px;
  border-radius: 24px;
  ${layerADark};
  ${flexBoxCenter};

  ${(p) =>
    p.isExpanded
      ? css`
          top: 602px;
          height: auto;
          padding: 2px 0;
        `
      : css`
          height: 47px;
        `}
`;
const InnerWrapper = styled.div`
  width: 244px;
  border-radius: 21px;
  ${layerA180Deg};

  ${(p) =>
    p.isExpanded
      ? css`
          height: auto;
          padding-top: 4.5px;
          ${flexDirectionColumn};
          justify-content: flex-start;
          padding-bottom: 6px;
        `
      : css`
          height: 43px;
          ${flexBoxCenter};
        `}
`;

const SelectedOneAndArrowButton = styled.div`
  width: 100%;
  ${justifyContentSpaceBetween};
  padding: 0 5px 0 8px;
`;
const SelectedOneWrapper = styled.div`
  width: 196px;
  height: 29px;
  border-radius: 22px;
  ${layerADark};
  ${justifyContentFlexStart};
  padding-left: 10px;
`;

const SelectedOne = styled.span`
  font-size: 10px;
`;

const ExpandButton = styled.button`
  height: 29px;
  width: 32px;
  ${flexBoxCenter};
  margin-top: 4px;
`;
const Icon = styled.img`
  height: 100%;
`;

const SelectWrapper = styled.div`
  ${flexDirectionColumn};
`;

const SectionButton = styled.section`
  width: 230px;
  ${justifyContentSpaceBetween};
`;
const Button = styled.button`
  width: 110px;
  height: 37px;
  border-radius: 18px;
  ${layerB};
  ${flexBoxCenter};
`;
const ButtonInner = styled.div`
  width: 108px;
  height: 35px;
  border-radius: 25px;
  ${layerA180Deg};
  ${flexBoxCenter};
`;

const ButtonHole = styled.div`
  width: 100px;
  height: 27px;
  border-radius: 18px;
  ${layerA};
  ${flexBoxCenter};
`;
const ButtonTop = styled.div`
  width: 98px;
  height: 25px;
  border-radius: 25px;
  ${layerA180Deg};
  ${flexBoxCenter};

  font-size: 12px;
`;
